// extracted by mini-css-extract-plugin
module.exports = {"base-table":"base-table-c2d0c747eee3b40b2ec3c5d975059300"};